import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import ErrorHandler from '../errorHandler/errorHandler';
import { DebounceInput } from 'react-debounce-input';

const propTypes = {
    validateUrl: PropTypes.string.isRequired
};

class UsernameContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            isValid: false
        };

        this.validateUsername = this.validateUsername.bind(this);
    }

    validateUsername(event) {
        const that = this;
        // event is only accessible here because of DebounceInput component.
        // Typically, you'd need to set event.persist
        axios
            .post(this.props.validateUrl, { username: event.target.value })
            .then(function (response) {
                if (response.data !== null) {
                    if (response.data.isValid) {
                        that.setState({
                            messages: [],
                            isValid: true
                        });
                    } else {
                        that.setState({
                            messages: response.data.messages,
                            isValid: false
                        });
                    }
                    that.props.onChange(that.state.isValid);
                }
            })
            .catch(function (error) {
                new ErrorHandler().logError(error);
            });
    }

    render() {
        let message;
        if (this.state.isValid) {
            message = (
                <div className="mfa-info-edit">
                    <p>
                        <span className="asc-icon asc-icon--circle-check">
                            <span className="asc-hidden">Check Icon</span>
                        </span>
                        Nice username!
                    </p>
                </div>
            );
        } else {
            message = (
                <div className="is-warning">
                    <ul className="asc-form-help">
                        {this.state.messages.map(m => (
                            <li key={m}>{m}</li>
                        ))}
                    </ul>
                </div>
            );
        }
        return (
            <div className="asc-form-group">
                <label className="asc-form-label" htmlFor="username">
                    <span className="is-required">Username</span>
                </label>
                <DebounceInput
                    className="asc-form-input"
                    onChange={this.validateUsername}
                    debounceTimeout={700}
                    placeholder="Username"
                    id="username"
                    type="text"
                    name="username"
                    maxLength="25"
                    required
                />
                {message}
            </div>
        );
    }
}

UsernameContainer.propTypes = propTypes;
export default UsernameContainer;
